import Cookies from 'js-cookie';
import { fetchWithTimeout } from '../helpers/utils';
import { getIpAddress } from './ip-address.service';
import { allowsFunctionalSync, functionalCookieConsent$ } from './consent.service';
export async function getPersonalizationCampaigns(config) {
    try {
        if (!allowsFunctionalSync()) {
            throw new Error("Functional cookies not allowed; unable to get personalization");
        }
        const body = buildBody(config);
        const ipAddress = await getIpAddress();
        if (ipAddress) {
            body.context.device.ip = ipAddress;
        }
        const res = await fetchWithTimeout(`${window.UNTUCKitConfig.dyApiBaseUrl}/serve/user/choose`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(body),
            headers: {
                'content-type': 'application/json',
                'dy-api-key': window.UNTUCKitConfig.dyApiKey
            }
        });
        const json = await res.json();
        // resetting DY cookies to update Max-Age attribute
        json.cookies.forEach((c) => {
            Cookies.set(c.name, c.value, {
                "Max-Age": c.maxAge,
                domain: window.location.hostname.replace('www', '') // mimic how DY adds the cookie domain
            });
        });
        if (json.warnings) {
            json.warnings.forEach((w) => console.warn(w.message));
        }
        return json;
    }
    catch (e) {
        console.warn("Unable to get personalization campaigns", e.message || e);
    }
}
/**
 * see: https://dy.dev/reference/track-engagement
 *
 */
export async function reportEngagement(engagements) {
    try {
        await fetch(`${window.UNTUCKitConfig.dyReportingApiBaseUrl}/collect/user/engagement`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(buildEngagementBody(engagements)),
            headers: {
                'content-type': 'application/json',
                'dy-api-key': window.UNTUCKitConfig.dyApiKey
            }
        });
    }
    catch (e) {
        console.error("Unable to report engagement", e.message || e);
    }
}
export function getPageType() {
    const pathname = window.location.pathname;
    if (pathname.includes('/products/')) {
        return 'PRODUCT';
    }
    else if (pathname.includes('/collections/')) {
        return 'CATEGORY';
    }
    else if (pathname.includes('/cart')) {
        return 'CART';
    }
    else if (pathname === '/') {
        return 'HOMEPAGE';
    }
    else {
        return 'OTHER';
    }
}
function buildBody(config) {
    const body = {
        ...getSharedProperties(),
        selector: {
            names: [...(config.apiSelectorNames || [])],
            groups: [...(config.groups || [])]
        },
        context: {
            page: {
                type: getPageType(),
                data: [...(config.data || [])],
                location: window.location.hostname + window.location.pathname,
                referrer: document.referrer
            },
            device: {}
        },
        options: {
            returnAnalyticsMetadata: true,
            isImplicitPageview: false,
            isImplicitClientData: true
        }
    };
    const params = new URLSearchParams(window.location.search);
    if (params.get('dyApiPreview')) {
        body.selector.preview = {
            ids: [params.get('dyApiPreview')]
        };
    }
    return body;
}
function buildEngagementBody(engagements) {
    const body = {
        ...getSharedProperties(),
        engagements
    };
    return body;
}
function getSharedProperties() {
    return {
        user: {
            dyid: Cookies.get('_dyid') || '',
            dyid_server: Cookies.get('_dyid_server') || '',
            active_consent_accepted: window.DY?.userActiveConsent?.accepted || false
        },
        session: {
            dy: Cookies.get('_dyjsession') || ''
        }
    };
}
functionalCookieConsent$.subscribe((consent) => {
    console.log("updating dy active consent", consent);
    if (window.DY?.userActiveConsent) {
        window.DY.userActiveConsent = { accepted: consent };
    }
    if (typeof window.DYO?.ActiveConsent?.updateConsentAcceptedStatus === 'function') {
        window.DYO.ActiveConsent.updateConsentAcceptedStatus(consent);
    }
    try {
        window.localStorage.setItem('dyUserActiveConsent', `${consent}`);
    }
    catch (err) {
        console.error("unable to save dy active consent", err);
    }
    if (!consent) {
        // DY requested we remove this cookie as they're not able to do so
        Cookies.remove('_dyid_server');
    }
});
